import React, { Component } from 'react';

import Grid from './Grid';
import Score from './Score';
import ScoreGroup from './ScoreGroup';
import Utils from '../Utils';

import '../styles/Board.css';

class Board extends Component {
  render() {
    const totalScore = Utils.calculateTotalScore(this.props.rowData, this.props.columnData);
    const rowScores = this.props.rowData.map(item => item.score);
    const columnScores = this.props.columnData.map(item => item.score);

    return (
      <div>
        { this.props.rowData.length > 0 &&
          <div>
            <div className="board-row">
              <Grid
                letters={this.props.gridArray}
                startLetters={this.props.startLetters}
                expansions={this.props.expansions}
                bonusCells={this.props.bonusCells}
                loading={this.props.loading}
                rowData={this.props.rowData}
                columnData={this.props.columnData}
                slideMode={this.props.slideMode}
                onCellSelection={this.props.onCellSelection}
                onSlide={this.props.onSlide}
              />
              <ScoreGroup direction="vertical" scores={rowScores} />
            </div>
            {/* The two rows line up only because they are the same width, each
                being centred on its own. A slide day puts an arrow strip either
                side of the board, so the same two strips are stood in below it
                -- one before the column scores and one before the total -- or
                the bottom row centres 30px out of step with the board above. */}
            <div className="board-row">
              { this.props.slideMode && <div className="board-slide-strip" /> }
              <ScoreGroup direction="horizontal" scores={columnScores} />
              { this.props.slideMode && <div className="board-slide-strip" /> }
              <Score total="true" score={totalScore} />
            </div>
          </div>
        }
      </div>
    );
  }
}

export default Board;
